// Copyright (C) 2025 Skylark Drones

export function downloadFile(data, fileName) {
  const url = window.URL.createObjectURL(new Blob([data]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()

  // Clean up to prevent memory leaks
  setTimeout(() => {
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  }, 0)
}

export async function getExportErrorDetails(err) {
  const responseText = await err?.response?.data?.text?.()
  if (!responseText) return null
  try {
    return JSON.parse(responseText)
  } catch (parseError) {
    return null
  }
}
